import type { UserRole } from "./auth-types";
import { loadProfile, saveAppJwt, saveProfile } from "./auth-session";

export type JoinSessionUser = {
  googleSub: string;
  email: string;
  role: string;
  enrollmentSummary?: string;
};

export type JoinSessionResponse = {
  accessToken?: string;
  tokenType?: string;
  user?: JoinSessionUser;
};

/** Apply optional session fields returned from POST /api/cohorts/join. */
export function applyJoinSessionResponse(result: JoinSessionResponse): void {
  if (result.accessToken) {
    saveAppJwt(result.accessToken);
  }
  if (!result.user) return;

  const role: UserRole =
    result.user.role === "teacher" || result.user.role === "student" || result.user.role === "pending"
      ? result.user.role
      : "pending";
  const enrollmentSummary =
    result.user.enrollmentSummary === "active" ||
    result.user.enrollmentSummary === "none" ||
    result.user.enrollmentSummary === "archived_only"
      ? result.user.enrollmentSummary
      : undefined;
  const prev = loadProfile();
  saveProfile({
    googleSub: result.user.googleSub,
    email: result.user.email,
    role,
    displayName: prev?.googleSub === result.user.googleSub ? prev.displayName : undefined,
    enrollmentSummary: enrollmentSummary ?? prev?.enrollmentSummary,
  });
}
